/** BCP-47 / URL segment for Brazilian Portuguese (must match server redirects + SEO). */
export const PT_BR_PREFIX = '/pt-br'

/**
 * Strips a leading `/pt-br` locale segment so feed/market URL parsers keep using `/markets`, `/q`, etc.
 * @param {string} pathname
 * @returns {string} Path starting with `/` (e.g. `/pt-br/markets` → `/markets`, `/pt-br` → `/`).
 */
export function pathnameWithoutLocalePrefix(pathname) {
  if (pathname == null || pathname === '') return '/'
  const normalized = pathname.replace(/\/$/, '') || '/'
  if (normalized === PT_BR_PREFIX) return '/'
  if (normalized.startsWith(`${PT_BR_PREFIX}/`)) {
    const rest = normalized.slice(PT_BR_PREFIX.length)
    return rest || '/'
  }
  return pathname
}

/**
 * @param {string} pathname
 * @returns {'' | '/pt-br'} Prefix to prepend when building in-app links on locale URLs.
 */
export function getLocalePrefix(pathname) {
  if (pathname == null || pathname === '') return ''
  const normalized = pathname.replace(/\/$/, '') || '/'
  if (normalized === PT_BR_PREFIX || normalized.startsWith(`${PT_BR_PREFIX}/`)) {
    return PT_BR_PREFIX
  }
  return ''
}

/**
 * Prepend `/pt-br` when `pathname` is a Portuguese URL. Paths that already
 * carry the prefix are left alone. English pathnames return `path` unchanged.
 * @param {string} pathname current request path
 * @param {string} path app path starting with `/`
 * @returns {string}
 */
export function withLocalePrefix(pathname, path) {
  const prefix = getLocalePrefix(pathname)
  const normalized = path ? (String(path).startsWith('/') ? String(path) : `/${path}`) : '/'
  if (!prefix || normalized === prefix || normalized.startsWith(`${prefix}/`)) return normalized
  return `${prefix}${normalized}`
}
